import { useMyContext } from "../components/myContext";
import { role_prefix } from "./settings";

export const getValidResource = (resource) => {
  const { acp } = useMyContext();

  if (!resource) return resource;

  const prefixed_role = acp.roles.find((role) => role in role_prefix);
  const prefix = role_prefix[prefixed_role];

  if (resource.startsWith(prefix)) {
    resource = resource.replace(prefix, "");
  }

  if (acp.isValidResource(resource)) {
    return resource;
  }

  return prefix + resource;
};
